<template lang="">
    <div class='container '>
        <router-view></router-view>
    </div>
</template>
<script setup>

</script>
<style lang="css">
    .container{
        padding: 1%;
    
    }
</style>